import { createContext } from 'react';
export const defaultFieldsetContext = {
  disabled: false,
  size: 'default'
};
export const FieldsetContext = /*#__PURE__*/createContext(defaultFieldsetContext);
const {
  Consumer,
  Provider
} = FieldsetContext;
export { Consumer as FieldsetContextConsumer, Provider as FieldsetContextProvider };
export { Consumer }; // Used downstream in FileManagerUI